import { experimentationFlagsApi } from "@circle-react/api/experimentationFlagsApi";
import { queryOptions, useQuery } from "react-query";

import type { ExperimentationFlagsResponse } from "../types/ExperimentationFlags";

const EXPERIMENTATION_FLAGS_REQUEST_KEY = [
  "community",
  "experimentation-flags",
];

export const experimentationFlagsQueryOptions = (communityId?: number) =>
  queryOptions<ExperimentationFlagsResponse>({
    queryKey: [...EXPERIMENTATION_FLAGS_REQUEST_KEY, communityId],
    queryFn: experimentationFlagsApi.fetch,
    staleTime: Infinity,
    gcTime: Infinity,
  });

interface UseExperimentationFlagsProps {
  communityId?: number;
  currentUserId?: number;
}

export const useExperimentationFlags = ({
  communityId,
  currentUserId,
}: UseExperimentationFlagsProps) => {
  const { data, isInitialLoading: isLoading } = useQuery({
    ...experimentationFlagsQueryOptions(communityId),
    enabled: !!communityId && !!currentUserId,
  });

  return {
    flags: data?.flags,
    experiments: data?.experiments,
    isLoading,
  };
};
